import script from "./callModal.vue?vue&type=script&setup=true&lang=js"
export * from "./callModal.vue?vue&type=script&setup=true&lang=js"

import "./callModal.vue?vue&type=style&index=0&id=10b53816&scoped=true&lang=css"

import exportComponent from "/var/www/html/koboeat/test/customer_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10b53816"]])

export default __exports__